import { z } from 'zod'
import { parseKwacha } from '@/lib/money'

export function amountToNgwee(text: string): number | null {
  const n = parseKwacha(text)
  return n !== null && n > 0 ? n : null
}

export const receiptFormSchema = z.object({
  receivedOn: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Pick the date it arrived'),
  amount: z.string().refine((v) => amountToNgwee(v) !== null, 'Enter an amount like 500 or 500.00'),
  method: z.enum(['cash', 'mobile_money', 'bank_transfer']),
  bankRef: z.string().trim().max(60, 'Use a shorter reference'),
  statementLineRef: z.string().trim().max(60, 'Use a shorter reference'),
  departmentId: z.string(), // '' = not claimed yet
  note: z.string().trim().max(300, 'Use a shorter note'),
})

export const textSchema = (what: string) =>
  z.object({ text: z.string().trim().min(3, `${what} (at least a few words)`).max(500, 'Use a shorter text') })
